import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'ham-toggle',
    templateUrl: './ham-toggle.component.html',
    styleUrls: ['./ham-toggle.component.scss'],
    host: {
        class: 'ham-toggle',
    },
})
export class HamToggle implements OnChanges {
    @Input() disabled: boolean = false;
    @Input() checked: boolean = false;

    @Input()
    get caption(): string {
        return this._caption;
    }
    set caption(value: string) {
        if (value !== this._caption) {
            this._caption = value;
        }
    }
    private _caption: string = '';

    private _formControlValue: UntypedFormControl | null = null;
    @Input()
    get formControlValue(): UntypedFormControl | null {
        return this._formControlValue;
    }
    set formControlValue(value: UntypedFormControl | null) {
        if (value !== this._formControlValue) {
            this._formControlValue = value;
            // Apply disabled state to the new form control
            if (this._formControlValue) {
                if (this.disabled) {
                    this._formControlValue.disable();
                } else {
                    this._formControlValue.enable();
                }
            }
        }
    }

    @Output() changed = new EventEmitter<boolean>();

    constructor(private el: ElementRef) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['disabled'] && this.formControlValue) {
            if (this.disabled) {
                this.formControlValue.disable();
            } else {
                this.formControlValue.enable();
            }
        }
    }

    onLabelClick(event: Event): void {
        if (this.disabled || (this.formControlValue && this.formControlValue.disabled)) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    onToggleChange(event: Event): void {
        if (this.disabled || (this.formControlValue && this.formControlValue.disabled)) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        const target = event.target as HTMLInputElement;
        this.changed.emit(target.checked);
    }
}
